import * as React from 'react';
import { Modal } from '@watcherr/ui';
import { t } from '~/i18n';

interface NoPermissionModalProps {
  onClose: () => void;
}

export const NoPermissionModal: React.FC<NoPermissionModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose} style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t(`permissions.no-permissions.title`)}</h3>
      <p>{t('permissions.no-permissions.description')}</p>
    </Modal>
  );
};
